import * as wf from "client-api-workflow";
import { useQuery } from "react-query";

const useRoles = () => {
  return useQuery(
    JSON.stringify(["all-roles"]),
    () => {
      return wf.getUserRoles().then((items) => {
        return items.data.map((item) => ({
          ...item,
          id: item._id || "",
          children: [],
          symbol: "",
          typename: "role",
          owner: "",
          topelement: "",
          periodlevel: "",
          periodlevelname: "",
        }));
      });
    },
    {
      cacheTime: 60 * 1000,
    }
  );
};

export default useRoles;
